import { render, staticRenderFns } from "./BLDWineEdit.vue?vue&type=template&id=5a199b79&scoped=true"
import script from "./BLDWineEdit.vue?vue&type=script&lang=js"
export * from "./BLDWineEdit.vue?vue&type=script&lang=js"
import style0 from "./BLDWineEdit.vue?vue&type=style&index=0&id=5a199b79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a199b79",
  null
  
)

export default component.exports